import serverData from 'ppbl/utils/server-data'

/**
 * Extracts the middle number as loan term from a string that starts with 'P' and ends with 'W'.
 * this is format term response from graphQl
 * @param {string} GqlTerm - The input string.
 * @returns {number|null} The middle number, or null if no number is found.
 */
export const extractTermFromGQLformatting = function (GqlTerm) {
  const match = GqlTerm.match(/^P(\d+)W$/)
  return match ? parseInt(match[1], 10) : null
}

/**
 * Extracts the 'token' parameter from a given URL and returns an object containing
 * the modified URL (without the 'token' parameter) and the token value.
 *
 * @param {string} url - The URL string from which to extract the token.
 * @returns {Object} An object containing the modified URL and the token and domain value.
 * @throws {Error} If the URL is invalid or the token is not found in the URL.
 */

export const getTokenFromUrl = function (url) {
  try {
    // Create a URL object from the given URL string
    const urlObj = new URL(url)

    // Use URLSearchParams to get the value of the 'token' parameter
    const params = new URLSearchParams(urlObj.search)
    const token = params.get('token')
    const domain = urlObj.origin

    if (!token) {
      throw new Error('Token not found in the URL')
    }

    // Remove the token parameter from the URL
    params.delete('token')
    urlObj.search = params.toString()

    return {
      url: urlObj.toString(),
      token,
      targetDomain: domain,
    }
  } catch (error) {
    throw new Error(`Failed to retrieve token from URL: ${error.message}`)
  }
}

export const redirectToServerRoute = (route) => {
  window.location.replace(route)
}

export const getApplicationTypeName = () => {
  const product = serverData?.startParams?.product

  const productNameMapping = {
    app: 'Loanbuilder application',
    'app-renewal': 'Loanbuilder Renewal application',
    paypal: 'PPBL application',
    'paypal-renewal': 'PPBL Renewal application',
  }

  return productNameMapping[product] || 'Loanbuilder application'
}

export const toPercentage = (value) => {
  const percentageValue = Number((value * 100).toFixed(6))
  return isNaN(percentageValue) ? 0 : percentageValue
}

export const toPercentageString = (value) => {
  const percentageValue = toPercentage(value)
  return `${percentageValue}%`
}
